import React from 'react';
import { Link } from 'react-router';
import WarningMessage from 'components/WarningMessage/WarningMessage';
import styles from './AccessApp.css';

class AccessApp extends React.Component {
  render() {
    const { checked, onChange, hasSubMenuChecked } = this.props;
    return (
      <div className="row">
        <div className="col-lg-1">
          <div
            style={{ marginTop: '2px' }}
            className={`checkbox checkbox-primary checkbox-circle ${
              !checked && hasSubMenuChecked ? styles['partial-checked'] : ''
            }`}
          >
            <input
              type="checkbox"
              id="access-app"
              onChange={onChange}
              checked={checked}
            />
            <label for="access-app" />
          </div>
        </div>
        <div className="col-lg-11" style={{ marginLeft: '-5px' }}>
          <div className={`${styles['access-app-title']}`}>
            App Permission (Moka POS & Moka Pay)
          </div>
          <div className={`${styles['access-app-description']}`}>
            Allow employees to sign in to your Point of Sale using their email
            and access the following.
          </div>
          <div className={`${styles['access-app-description']}`}>
            To set a 4-digit PIN for these permissions instead, go to{' '}
            <Link to="/employees/pin" target="_blank">
              PIN Access
            </Link>
            .
          </div>
          <div
            style={{ marginTop: '20px' }}
            className={styles['app-version-warning']}
          >
            <WarningMessage
              message="App permissions require at least Moka v.24.6 on iOS and Moka v.14.2 on Android."
              iconStyle={`circle`}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default AccessApp;
